import {IAction, ActionType} from '../Actions';
import {IRemoteConfig} from '../../config/RemoteConfig';

export const setRemoteConfig = (
  config: IRemoteConfig,
): IAction<IRemoteConfig> => ({
  type: ActionType.SET_REMOTE_CONFIG,
  payload: config,
});
